function getPathValue(source, path) {
    if (!source || !path) return null
    return String(path).split('.').reduce((value, key) => {
        if (value === null || value === undefined) return null
        return value[key]
    }, source)
}

function getOrganization(document, organizationPaths) {
    for (const path of organizationPaths || []) {
        const organization = getPathValue(document, path)
        if (organization && organization._id !== null && organization._id !== undefined) {
            return organization
        }
    }
    return null
}

export const PRINT_TEMPLATE_LAYOUTS_KEY = '__printTemplateLayouts'
const DEFAULT_ONLY_TEMPLATE_TYPES = ['物品调拨单', '销售报价单']

export function supportsScopedPrintTemplate(danjuleixing) {
    return DEFAULT_ONLY_TEMPLATE_TYPES.indexOf(danjuleixing) === -1
}

export function setPrintTemplateFootItem(printlayout, item, enabled) {
    const layouts = (printlayout && printlayout[PRINT_TEMPLATE_LAYOUTS_KEY]) || (printlayout ? [printlayout] : [])
    const handledLayouts = []

    for (const layout of layouts) {
        if (!layout || handledLayouts.indexOf(layout) !== -1) continue
        handledLayouts.push(layout)

        const items = layout.foot && layout.foot.items
        if (!Array.isArray(items)) continue

        const exists = items.some(current => current && current.key === item.key)
        if (enabled && !exists) {
            items.push({ ...item })
        } else if (!enabled && exists) {
            for (let index = items.length - 1; index >= 0; index--) {
                if (items[index] && items[index].key === item.key) items.splice(index, 1)
            }
        }
    }

    return printlayout
}

export function resolvePrintTemplateScope(documents = [], organizationPaths = []) {
    const jigouIds = []
    const jigouIdKeys = []

    for (const document of documents || []) {
        const organization = getOrganization(document, organizationPaths)
        if (!organization) continue

        const jigouId = organization._id
        const jigouIdKey = String(jigouId)
        if (jigouIdKeys.indexOf(jigouIdKey) === -1) {
            jigouIdKeys.push(jigouIdKey)
            jigouIds.push(jigouId)
        }
    }

    return {
        jigouId: jigouIds.length === 1 ? jigouIds[0] : null,
        jigouIds,
    }
}

export function loadPrintTemplate(vm, { name, documents = [], organizationPaths = [] }) {
    const documentJigouIds = (documents || []).map(document => {
        const organization = getOrganization(document, organizationPaths)
        return organization ? organization._id : null
    })
    const requestJigouIds = []
    const requestKeys = []
    for (const jigouId of documentJigouIds) {
        const key = jigouId === null || jigouId === undefined ? '__default__' : String(jigouId)
        if (requestKeys.indexOf(key) === -1) {
            requestKeys.push(key)
            requestJigouIds.push(jigouId)
        }
    }

    if (requestJigouIds.length === 0) {
        requestKeys.push('__default__')
        requestJigouIds.push(null)
    }

    return Promise.all(requestJigouIds.map(jigouId => {
        return vm.$api.post('/web/main/dayinmoban/load', {
            name,
            jigouId,
        }).then(res => res.data.dayinmoban)
    })).then(layouts => {
        if (layouts.length === 1) return layouts[0]

        const layoutsByKey = requestKeys.reduce((result, key, index) => {
            result[key] = layouts[index]
            return result
        }, {})
        return {
            [PRINT_TEMPLATE_LAYOUTS_KEY]: documentJigouIds.map(jigouId => {
                const key = jigouId === null || jigouId === undefined ? '__default__' : String(jigouId)
                return layoutsByKey[key]
            }),
        }
    })
}



// WEBPACK FOOTER //
// ./src/helpers/printTemplate.js